<template>
    <div class="fba-page-header">
        <div class="fba-page-header-row">
            <div class="fba-page-header-title-wrapper d-flex" style="justify-content: space-between">
                <div class="d-flex align-items-center" style="gap: 1rem">
                    <router-link v-if="backRoute" :to="backRoute" class="btn btn-outline-secondary btn-sm">
                        <i class="fas fa-arrow-left"></i>
                    </router-link>
                    <h1 class="fba-page-header-title" style="margin-top: 0.5rem">{{ title }}</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageHeader',
    props: {
        title: {
            type: String,
            required: true,
        },
        backRoute: {
            type: String,
            default: null,
        },
    },
}
</script>
